module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/barcode-scan-aa45eab59162e0077bcd6c9ce8454397.svg";